// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { memo, useCallback, useEffect } from 'react'
import classNames from 'classnames'
import './LicensedStatesTool.scss'
import Switch from 'react-switch'
import EditLicensedStatesDropdown from './edit-licensed-states-dropdown/EditLicensedStatesDropdown'
import { generateStatesAbbrArrayFromStateFullNamesArray } from '../../../../utils/common'

const LicensedStatesTool = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    className,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    availableStates,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setAvailableStates,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    availableStatesDropdownError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setAvailableStatesDropdownError,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    initialOverriddenStatesCodes,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsShowSelectRecursionChangeModePopUp,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    availableStatesCodeArray,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isRecursive,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setIsEditLicensedStatesModeOn,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isEditLicensedStatesModeOn,
  }) => {
    useEffect(() => {
      if (isRecursive) {
        if (
          generateStatesAbbrArrayFromStateFullNamesArray(availableStatesCodeArray).join(',') ===
          initialOverriddenStatesCodes.join(',')
        ) {
          setIsShowSelectRecursionChangeModePopUp(false)
        } else {
          setIsShowSelectRecursionChangeModePopUp(true)
        }
      }
    }, [availableStatesCodeArray, initialOverriddenStatesCodes, isRecursive, setIsShowSelectRecursionChangeModePopUp])

    const changeSwitchValue = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (newValue) => {
        if (!newValue) {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          setAvailableStates((prev) => prev.map((t) => ({ ...t, isActive: true })))
        }
        setAvailableStatesDropdownError('')
        return newValue
      },
      [setAvailableStates, setAvailableStatesDropdownError],
    )

    const onChangeLicensedStatesToolMode = useCallback(() => {
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      setIsEditLicensedStatesModeOn((prev) => changeSwitchValue(!prev))
    }, [changeSwitchValue, setIsEditLicensedStatesModeOn])

    const onChangeAvailableStates = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (newStates) => {
        setAvailableStatesDropdownError('')
        setAvailableStates(newStates)
      },
      [setAvailableStates, setAvailableStatesDropdownError],
    )

    return (
      <div className={classNames('licensed-state-tool-container', {}, [className])}>
        <div className={classNames('licensed-state-tool', {}, [className])}>
          <span className='licensed-state-tool-label'>Applies to all licensed states</span>
          <Switch
            onChange={onChangeLicensedStatesToolMode}
            checked={!isEditLicensedStatesModeOn}
            offColor='#B0BDCB'
            onColor='#00A2B2'
            height={30}
            width={66}
            uncheckedIcon={<div className='licensed-state-tool-switcher-off-container'> off </div>}
            checkedIcon={<div className='licensed-state-tool-switcher-on-container'> on </div>}
            activeBoxShadow='#ffffff'
          />
        </div>
        {isEditLicensedStatesModeOn ?
          <EditLicensedStatesDropdown
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            availableStatesDropdownError={availableStatesDropdownError}
            setAvailableStatesDropdownError={setAvailableStatesDropdownError}
            availableStates={availableStates}
            setAvailableStates={onChangeAvailableStates}
            className='licensed-state-tool-edit-mode'
          />
        : null}
      </div>
    )
  },
)

export default LicensedStatesTool
